// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"00c772c9","332":"7e9e1690","453":"d855a71b","485":"d97c4317","510":"63d488a1","673":"b7c1ccb3","675":"a645f6f1","725":"0c6ac171","875":"d72ce224","908":"9e3de99d"}[chunkId] + ".chunk.js";
};